import { Suspense, lazy } from 'react';
import { useDemoPlayer } from '@/store/useDemoPlayer';

// T2908: predvajalnik z registrom demov se naloži šele, ko nekdo odpre demo (klik na gumb).
const DemoPlayerModal = lazy(() => import('./DemoPlayerModal'));

export default function LazyDemoPlayerModal() {
  const openId = useDemoPlayer((s) => s.openId);
  if (!openId) return null;
  return (
    <Suspense fallback={null}>
      <DemoPlayerModal />
    </Suspense>
  );
}
